import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../../shared/services/environment-url';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserModel } from '../../_interfaces/user';
import { UserService } from '../../shared/services/user-service';
import { EditorModule } from '@openng/optimus-ui/editor';
import { CardModule } from '@openng/optimus-ui/card';
import { TableModule } from '@openng/optimus-ui/table';
import { ButtonModule } from '@openng/optimus-ui/button';
import { SelectModule } from '@openng/optimus-ui/select';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-user',
  imports: [
    TableModule,
    ButtonModule,
    FormsModule,
    SelectModule,
    CommonModule,
    EditorModule,
    CardModule,
  ],
  templateUrl: './edit-user.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit-user.css',
})
export class EditUser {
  @Input() id!: string;
  userService?: UserService;
  roles: string[] = ['Admin', 'User'];
  data: UserModel = {
    id: -1,
    email: '',
    password: '',
    confirmPassword: '',
    role: '',
    displayName: '',
  };

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
    private router: Router,
  ) {
    this.userService = new UserService(this.http, this.envUrl);
  }

  ngAfterViewInit() {
    if (this.id != '') {
      this.userService?.get(this.id).subscribe((at) => {
        this.data = at as UserModel;
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  Save(): void {
    if (this.id != '') {
      this.userService?.update(this.id, this.data).subscribe(() => {
        this.router.navigateByUrl('/users');
      });
    } else {
      this.userService?.create(this.data).subscribe(() => {
        this.router.navigateByUrl('/users');
      });
    }
  }

  Cansle(): void {
    this.router.navigateByUrl('/users');
  }
}
